import {Permissions} from "@/js/Permissions";

const UserRoutes = [
  {
    path: "/users",
    name: "users_index",
    component: () => import("@/views/admin/users/IndexView.vue"),
    meta: {permissions: [Permissions.ADMIN]},
  },
  {
    path: "/users/create",
    name: "users_create",
    component: () => import("@/views/admin/users/CreateView.vue"),
    meta: {permissions: [Permissions.ADMIN]},
  },
  {
    path: "/users/:id",
    name: "users_edit",
    component: () => import("@/views/admin/users/EditView.vue"),
    meta: {permissions: [Permissions.ADMIN]},
  },
]

export default UserRoutes;
